export default "__VITE_ASSET__DtitGX6F__"